export const RESET = 'EXSBINVOICEPOSITION_UPDATE_RESET'
export const SET_ERROR = 'EXSBINVOICEPOSITION_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBINVOICEPOSITION_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBINVOICEPOSITION_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBINVOICEPOSITION_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBINVOICEPOSITION_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBINVOICEPOSITION_UPDATE_UPDATE_RETRIEVED'
